import APU from "../../assets/images/apu.webp";
import Curtin from "../../assets/images/curtin-malaysia.webp";
import Help from "../../assets/images/help.webp";
import HeriotWatt from "../../assets/images/heriot-watt-university-malaysia.webp";
import IGlobal from "../../assets/images/iglobal.webp";
import Manipal from "../../assets/images/manipal-university-college.webp";
import MIA from "../../assets/images/mia.webp";
import QIU from "../../assets/images/qiu.webp";
import Raffles from "../../assets/images/raffles-university.webp";
import Segi from "../../assets/images/segi.webp";
import Southampton from "../../assets/images/university-of-southampton-malaysia.webp";
import YTL from "../../assets/images/ytl.webp";
import Reading from "../../assets/images/university-of-reading-malaysia.webp";
import UOC from "../../assets/images/university-of-cyberjaya.webp";
import UOW from "../../assets/images/uow.webp";

export const featuredUniversities = [
  {
    id: 1,
    image: APU,
    name: "Asia Pacific University (APU)",
    description: "获奖大学，专注于科技、创新与创意",
    scholarship: "最高可享 50% 奖学金",
    color: "from-orange-400 to-pink-500",
  },
  {
    id: 2,
    image: HeriotWatt,
    name: "Heriot-Watt University Malaysia",
    description: "以马来西亚学费获取英国学位 — 工程、商业及更多专业",
    scholarship: "最高可享 30% 奖学金",
    color: "from-purple-400 to-indigo-500",
  },
  {
    id: 3,
    image: Curtin,
    name: "Curtin University Malaysia",
    description: "澳大利亚大学，提供国际认可的工程、商业等专业学位课程",
    scholarship: "最高可享MYR 10,000奖学金",
    color: "from-amber-400 to-orange-500",
  },
  {
    id: 4,
    image: Segi,
    name: "SEGi University",
    description: "领先的医疗、商业与工程大学，提供高性价比优质教育",
    scholarship: "最高可享 35% 奖学金",
    color: "from-pink-400 to-rose-500",
  },
];

export const benefits = [
  {
    title: "更高额奖学金",
    description: "享有其他地方无法获得的独家奖学金优惠",
    emoji: "💰",
  },
  {
    title: "额外回扣优惠",
    description: "通过 SCS Education 提前申请可获得额外回扣",
    emoji: "🎁",
  },
  // {
  //   title: "直通大学申请",
  //   description: "凭借我们与大学的直接合作关系，加速您的申请流程",
  //   emoji: "⚡",
  // },
  {
    title: "经验丰富的升学顾问团队",
    description: "我们的团队拥有超过 10 年的教育咨询经验",
    emoji: "🎓",
  },
  {
    title: "安排校园参观",
    description: "我们为您安排校园参观，让您在决定前亲自体验校园环境",
    emoji: "🏫",
  },
  {
    title: "深受全马学生信任",
    description: "已有成千上万名学生在我们的专业指导下成功升学",
    emoji: "⭐",
  },
  {
    title: "快速且个性化的升学指导",
    description: "根据您的 SPM/UEC 成绩与升学目标量身定制建议",
    emoji: "🚀",
  },
];

export const testimonials = [
  {
    name: "Garyee Tai",
    quote:
      "Because I don't know which university to go to, and I don't know what courses to study. I met Genusis Liew, the counselor and in the end her patiently helped me find the courses which suit me and near my house which is APU and even got a scholarship",
    uni: "APU Student",
    color: "bg-gradient-to-br from-orange-100 to-pink-100",
  },
  {
    name: "Jiaxuan",
    quote:
      "A big thanks to SCS Education, especially Eunice. She was incredibly patient, supportive,professional and responded quickly throughout my university application journey. Thanks to her guidance, I was successfully accepted into APU University and received a scholarship. If you are unsure about which course to choose or which university to enroll in, don’t worry. They offer a personality assessment and will recommend the most suitable university based on your interests, budget. Thanks again to Eunice and SCS Education!",
    uni: "APU Student",
    color: "bg-gradient-to-br from-purple-100 to-indigo-100",
  },
  {
    name: "Anonymous",
    quote:
      "Thank you so much for the great service. I'm glad that SCS helping me to get 50% scholarships for my diploma study and free hostels for 4 months in UOW Malaysia.",
    uni: "UOW Malaysia Student",
    color: "bg-gradient-to-br from-amber-100 to-orange-100",
  },
];

export const faqs = [
  {
    question: "我该如何通过 SCS Education 申请？",
    answer:
      "只需填写表格，我们的升学顾问将在 24 小时内联系您，并全程指导您的申请流程。",
  },
  {
    question: "是否有任何服务费用？",
    answer: "没有！我们的升学咨询与申请服务对学生完全免费。",
  },
  {
    question: "申请流程需要多久？",
    answer: "凭借我们与大学的直接合作关系，申请通常可在 24 小时内完成处理。",
  },
  {
    question: "我需要准备哪些文件？",
    answer:
      "您需要准备 SPM/UEC 成绩、身份证或护照副本，以及护照尺寸照片。具体要求我们将逐一为您说明。",
  },
  {
    question: "我可以用 SPM/UEC 试考成绩申请奖学金吗？",
    answer:
      "可以！我们与多所大学合作，提供不同成绩等级的奖学金，欢迎联系我们了解更多详情。",
  },
];

export const moreUniversities = [
  {
    name: "APU",
    image: APU,
    fullName: "Asia Pacific University (APU)",
    location: "Bukit Jalil, Kuala Lumpur",
    ranking: "QS东南亚前50",
    scholarships: "7项奖学金",
    employment: "毕业生100%就业率",
    description:
      "来自130多个国家的学生汇聚于此，APU 以高素质毕业生和在本地及国际层面的卓越成就，成为领先的科技型获奖大学。",
    courses: [
      { name: "计算机与信息技术", fee: "MYR 26,400" },
      { name: "工程学", fee: "MYR 26,400" },
      { name: "商业学", fee: "MYR 26,400" },
      { name: "会计与金融", fee: "MYR 26,400" },
    ],
    color: "from-rose-400 to-pink-500",
  },
  {
    name: "Curtin",
    image: Curtin,
    fullName: "Curtin University Malaysia",
    location: "Miri, Sarawak",
    ranking: "QS世界前200",
    scholarships: "7项奖学金",
    employment: "毕业生96%就业率",
    description: "澳大利亚大学，提供国际认可的工程、商业等专业学位课程。",
    courses: [
      { name: "工程学", fee: "MYR 27,200" },
      { name: "商业学", fee: "MYR 27,300" },
      { name: "计算机", fee: "MYR 34,500" },
      { name: "科学", fee: "MYR 27,300" },
    ],
    color: "from-yellow-400 to-orange-500",
  },
  {
    name: "Heriot-Watt",
    image: HeriotWatt,
    fullName: "Heriot-Watt University Malaysia",
    location: "Putrajaya",
    ranking: "QS世界前300",
    scholarships: "6项奖学金",
    employment: "毕业生97%就业率",
    description:
      "以马来西亚学费用获取英国学位，提供符合英式教育标准的工程、商业等课程。",
    courses: [
      { name: "工程学", fee: "MYR 49,620" },
      { name: "商业学", fee: "MYR 25,710" },
      { name: "建筑环境", fee: "MYR 39,000" },
      { name: "心理学", fee: "MYR 35,400" },
    ],
    color: "from-purple-400 to-indigo-500",
  },
  {
    name: "SEGi",
    image: Segi,
    fullName: "SEGi University",
    location: "Kota Damansara, Selangor",
    ranking: "顶级医疗保健大学",
    scholarships: "10项奖学金",
    employment: "毕业生92%就业率",
    description: "在医疗、商业和工程领域具备领先实力，提供高性价比的优质教育。",
    courses: [
      { name: "护理学", fee: "MYR 27,000" },
      { name: "商业学", fee: "MYR 37,700" },
      { name: "工程学", fee: "MYR 37,700" },
      { name: "药学", fee: "MYR 103,360" },
    ],
    color: "from-sky-400 to-blue-500",
  },
  {
    name: "Help",
    image: Help,
    fullName: "Help University",
    location: "Subang Bestari, Shah Alam",
    ranking: "QS亚洲前620",
    scholarships: "10项以上奖学金",
    employment: "毕业生99.9%就业率",
    description:
      "马来西亚知名私立大学，以实务导向课程著称，重点发展商业、心理学与教育领域。",
    courses: [
      { name: "心理学", fee: "MYR 97,500" },
      { name: "法律", fee: "MYR 77,190" },
      { name: "教育学", fee: "MYR 16,400" },
    ],
    color: "from-blue-400 to-cyan-500",
  },
  {
    name: "IGlobal",
    image: IGlobal,
    fullName: "IGlobal Academy",
    location: "Shah Alam, Selangor",
    ranking: "全球化卓越教育",
    scholarships: "10项以上奖学金",
    employment: "毕业生90%就业率",
    description:
      "马来西亚注册HRDF的私立培训与商学院，提供国际认可的文凭、本科与硕士课程。",
    courses: [
      { name: "商业与管理", fee: "MYR 13,800" },
      { name: "会计与金融", fee: "MYR 13,800" },
      { name: "数字营销与创意商业", fee: "MYR 10,800" },
    ],
    color: "from-green-400 to-emerald-500",
  },
  {
    name: "MUCM",
    image: Manipal,
    fullName: "Manipal University College Malaysia",
    location: "Bukit Baru, Melaka",
    ranking: "马来西亚第43名",
    scholarships: "10项以上奖学金",
    employment: "毕业生92%就业率",
    description: "提供国际认可的工程、商业与健康科学课程，注重全球教育标准。",
    courses: [
      { name: "医学 / 牙科及相关健康专业", fee: "MYR 360,000" },
      { name: "健康与医学科学（非医生类）", fee: "MYR 49,725" },
      { name: "大学预科 / 基础课程", fee: "MYR 16,000" },
    ],
    color: "from-red-400 to-pink-500",
  },
  {
    name: "MIA",
    image: MIA,
    fullName: "Malaysian Institute of Art",
    location: "Taman Melawati, Kuala Lumpur",
    ranking: "马来西亚第104名",
    scholarships: "10项以上奖学金",
    employment: "毕业生90%就业率",
    description:
      "马来西亚领先的私立艺术学院，专注于创意艺术、设计与视觉传达教育。",
    courses: [
      { name: "室内设计 / 室内建筑设计", fee: "MYR 37,290" },
      { name: "平面 / 数字 / 纯艺术与设计", fee: "MYR 36,300" },
      { name: "艺术与设计基础 / 证书课程", fee: "MYR 9,000" },
    ],
    color: "from-indigo-400 to-purple-500",
  },
  {
    name: "QIU",
    image: QIU,
    fullName: "Quest International University",
    location: "Ipoh, Perak",
    ranking: "马来西亚第68名",
    scholarships: "10项以上奖学金",
    employment: "毕业生90%就业率",
    description:
      "以研究为导向的私立大学，提供贴合行业需求的课程，培养具备专业能力与社会责任感的毕业生。",
    courses: [
      { name: "商业 / 管理 / 商贸", fee: "MYR 12,800" },
      { name: "计算机 / IT / 计算机科学", fee: "MYR 15,300" },
      {
        name: "工程 / 科技 / 机电 / 电子",
        fee: "MYR 28,400",
      },
      { name: "医学 / 健康科学", fee: "MYR 138,400" },
    ],
    color: "from-amber-400 to-orange-500",
  },
  {
    name: "Raffles",
    image: Raffles,
    fullName: "Raffles University",
    location: "Johor Bahru, Johor",
    ranking: "马来西亚第74名",
    scholarships: "10项以上奖学金",
    employment: "毕业生98%就业率",
    description:
      "注重实务教学与真实项目结合，培养设计、商业、人工智能与社会科学领域的专业人才。",
    courses: [
      { name: "商业 / 管理 / 商贸", fee: "MYR 24,150" },
      {
        name: "信息技术 / 数据科学 / 人工智能 / 计算机",
        fee: "MYR 47,250",
      },
      {
        name: "设计 / 创意 / 多媒体 / 室内设计",
        fee: "MYR 24,150",
      },
      { name: "社会科学 / 心理学", fee: "MYR 84,400" },
    ],
    color: "from-pink-400 to-rose-500",
  },
  {
    name: "UOSM",
    image: Southampton,
    fullName: "University of Southampton Malaysia",
    location: "Iskandar Puteri, Johor",
    ranking: "马来西亚第72名",
    scholarships: "10项以上奖学金",
    employment: "毕业生98%就业率",
    description:
      "英国南安普顿大学马来西亚分校，提供符合英国标准的工程、计算机与商业学位。",
    courses: [
      { name: "计算机科学 / IT", fee: "MYR 126,000" },
      {
        name: "商业 / 管理 / 金融 / 会计",
        fee: "MYR 121,455",
      },
      {
        name: "工程学",
        fee: "MYR 206,800",
      },
    ],
    color: "from-teal-400 to-cyan-500",
  },
  {
    name: "YTL",
    image: YTL,
    fullName: "YTL International College of Management",
    location: "Bukit Bintang, Kuala Lumpur",
    ranking: "马来西亚第186名",
    scholarships: "10项以上奖学金",
    employment: "YTL 酒店与度假村 56% 就业率",
    description:
      "专注酒店、餐饮、活动与酒店管理教育，采用真实酒店校园与行业实习模式培养学生。",
    courses: [
      { name: "酒店管理文凭", fee: "MYR 42,000" },
      {
        name: "烹饪艺术文凭",
        fee: "MYR 42,000",
      },
      {
        name: "活动管理文凭",
        fee: "MYR 42,000",
      },
    ],
    color: "from-rose-400 to-pink-500",
  },
  {
    name: "UOR",
    image: Reading,
    fullName: "University of Reading Malaysia",
    location: "Iskandar Puteri, Johor",
    ranking: "2026年 QS 世界第194名",
    scholarships: "10项以上奖学金",
    employment: "毕业生98%就业率",
    description:
      "英国雷丁大学马来西亚分校，提供商业、法律、金融、心理学与建筑环境相关的英式学位。",
    courses: [
      { name: "商业与管理学士", fee: "MYR 40,800" },
      { name: "会计与金融学士", fee: "MYR 40,800" },
      { name: "心理学学士", fee: "MYR 37,600" },
      { name: "法律学士", fee: "MYR 40,800" },
    ],
    color: "from-rose-400 to-pink-500",
  },
  {
    name: "UOC",
    image: UOC,
    fullName: "University of Cyberjaya Malaysia",
    location: "Cyberjaya",
    ranking: "2026年 QS 世界 951–1000 名",
    scholarships: "10项以上奖学金",
    employment: "毕业生94.5%就业率",
    description:
      "专注健康科学、医学与相关专业的私立大学，提供具备行业认证的专业学位。",
    courses: [
      { name: "药学学士（荣誉）", fee: "MYR 124,400" },
      {
        name: "物理治疗学士（荣誉）",
        fee: "MYR 94,400",
      },
      {
        name: "工商管理学士（荣誉）",
        fee: "MYR 53,800",
      },
    ],
    color: "from-yellow-400 to-orange-500",
  },
  {
    name: "UOW",
    image: UOW,
    fullName: "University of Wollongong Malaysia",
    location: "Iskandar Puteri, Johor",
    ranking: "2026年 QS 世界第184名",
    scholarships: "10项以上奖学金",
    employment: "毕业生95.7%就业率",
    description:
      "澳大利亚伍伦贡大学马来西亚分校，提供工程、IT、商业与科学类国际认可学位。",
    courses: [
      { name: "商业与管理", fee: "MYR 23,400" },
      {
        name: "计算机与信息技术",
        fee: "MYR 22,815",
      },
      {
        name: "会计与金融",
        fee: "MYR 11,950",
      },
    ],
    color: "from-purple-400 to-indigo-500",
  },
];

export const footerData = {
  aboutTitle: "关于 SCS Education",
  aboutDesc:
    "SCS Education 是马来西亚领先的一站式教育服务中心，专为SPM、O-Level、STPM、UEC 和 A-Level 学生提供指导——包括课程咨询、大学资讯、奖学金申请协助以及职业规划等服务。",
  partnerUniTitle: "合作大学",
  partnerUni: [
    "APU",
    "Curtin",
    "Heriot-Watt",
    "SEGi",
    "Help",
    "IGlobal",
    "MUCM",
    "MIA",
    "QIU",
    "Raffles",
    "UOSM",
    "YTL",
    "UOR",
    "UOC",
    "UOW",
  ],
  contactTitle: "联系信息",
  contact: [
    "📞 电话: 011-12870256",
    "✉️ 邮箱: ng.scseducation@gmail.com",
    "📌 办公室: Kuantan (总部), Shah Alam, Sitiawan",
  ],
};
